import React, { useState } from "react";
import OTPVerification from "./OTPVerification";
import useForgotPassword from "../hooks/useForgotPassword";
import useVerifyOTP from "../hooks/useVerifyOTP";

const ForgotPassword = ({ onBackToLogin }) => {
  const [step, setStep] = useState("forgot"); // "forgot" | "otp"
  const [email, setEmail] = useState("");

  const { forgotPassword, error, isLoading, success } = useForgotPassword();
  const { verifyOTP } = useVerifyOTP();

  const handleForgot = async () => {
    const res = await forgotPassword({ email });
    if (res.success) {
      setStep("otp"); // switch to OTPVerification
    }
  };

  const handleVerifyOTP = async ({ email, otp }) => {
    return await verifyOTP({ email, otp });
  };

  const handleResendOTP = async ({ email }) => {
    return await forgotPassword({ email });
  };

  const handleBack = () => {
    setStep("forgot");
  };

  const handleSuccess = () => {
    console.log("OTP verified, redirect to reset password page");
    // optionally: onBackToLogin(); or navigate to reset page
  };

  if (step === "otp") {
    return (
      <div className="flex flex-col justify-center p-8 w-full md:w-1/2 bg-white rounded-r-xl shadow-lg">
        <OTPVerification
          email={email}
          onVerifyOTP={handleVerifyOTP}
          onResendOTP={handleResendOTP}
          onBack={handleBack}
          onSuccess={handleSuccess}
        />
      </div>
    );
  }

  // Default Forgot Password UI in same style as LoginRight
  return (
    <div className="flex flex-col justify-center p-8 w-full md:w-1/2 bg-white rounded-r-xl shadow-lg">
      <h2 className="text-3xl font-bold mb-2 text-black text-center">
        Forgot Password
      </h2>
      <p className="text-gray-600 text-sm mb-6 text-center">
        Enter your email and we’ll send you an OTP
      </p>

      {error && (
        <p className="text-red-600 mb-4 text-center font-medium">{error}</p>
      )}
      {success && (
        <p className="text-green-600 mb-4 text-center font-medium">
          OTP sent to your email
        </p>
      )}

      <div className="flex flex-col gap-4 ml-10 mr-10">
        <div className="flex flex-col">
          <label className="mb-1 text-black font-medium">Email Address</label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-black transition"
          />
        </div>

        <button
          onClick={handleForgot}
          disabled={isLoading || !email.trim()}
          className={`w-full ${isLoading || !email.trim()
            ? "bg-gray-500 cursor-not-allowed"
            : "bg-black hover:bg-gray-800"} text-white font-semibold py-3 rounded-lg transition`}
        >
          {isLoading ? "Sending..." : "Send OTP"}
        </button>

        <button
          onClick={onBackToLogin}
          className="w-full mt-2 text-sm text-gray-600 hover:text-black underline"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
